import React, { useEffect, useMemo } from 'react';
import { pick } from 'ramda';
import { useAppSelector } from 'js/store/hooks';
import { MaintenancePage } from './components/MaintenancePage';
import { useTogglePreloader } from 'js/components/system/App/hooks';

import * as helpers from './helpers';

export const Maintenance: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const togglePreloader = useTogglePreloader();
    const { isIntegrationScriptLoaded, maintenance } = useAppSelector(pick(['isIntegrationScriptLoaded', 'maintenance']));
    const isMaintenanceModeEnabled = useMemo(() =>
        helpers.isMaintenanceModeEnabled(maintenance, isIntegrationScriptLoaded), [maintenance, isIntegrationScriptLoaded]);

    useEffect(() => {
        if (isMaintenanceModeEnabled) {
            togglePreloader(true);
        }
    }, [isMaintenanceModeEnabled, togglePreloader]);

    if (isMaintenanceModeEnabled) {
        return <MaintenancePage />;
    }

    return (
        <>
            {children}
        </>
    );
};
